<template>
  <div>
    <CRow>
      <CCol sm="6" lg="3">
        <CCard  >
          <CCardBody>
            <CRow>
              <CCol  >
                <CRow><font-awesome-icon color="#39f"  class="mt-4 ml-5" icon="users"  size="3x" />
                  <CCol sm="6">
                    <CCallout color="info">
                      <label class="text-muted">  Total Member</label><br>
                      <strong class="h4">{{datas.data.totalmember}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>

      </CCol>
      <CCol sm="6" lg="3">
        <CCard >
          <CCardBody>
            <CRow>
              <CCol >
                <CRow> <font-awesome-icon color="#f9b115" class="mt-4 ml-5" icon="child"  size="3x" />
                  <CCol sm="6">
                    <CCallout color="warning">
                      <label class="text-muted">Total iKids</label><br>
                      <strong class="h4">{{datas.data.totalikid}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>

      </CCol>
      <CCol sm="6" lg="3">
        <CCard >
          <CCardBody>
            <CRow>
              <CCol >
                <CRow><font-awesome-icon color="#28a745 "  class="mt-4 ml-5" icon="home"  size="3x" />
                  <CCol sm="6">
                    <CCallout color="success">
                      <label class="text-muted">Total iCare</label><br>
                      <strong class="h4">{{datas.data.totalicare}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>

      </CCol>
      <CCol sm="6" lg="3">
        <CCard >
          <CCardBody>
            <CRow>
              <CCol >
                <CRow><font-awesome-icon color="#e55353" class="mt-4 ml-5" icon="user-plus"  size="3x" />
                  <CCol sm="7">
                    <CCallout color="danger">
                      <label class="text-muted">Total Newcomer</label><br>
                      <strong class="h4">{{datas.data.totalnewcomer}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>
      </CCol>
    </CRow>


<!-- ROW 2 -->
    <CRow>
      <CCol sm="6" lg="3">
        <CCard >
          <CCardBody>
            <CRow>
              <CCol >
                <CRow><font-awesome-icon color="#39f"  class="mt-4 ml-5" icon="users"  size="3x" />
                  <CCol sm="6">
                    <CCallout color="info">
                      <label class="text-muted">  Total iCare Member</label><br>
                      <strong class="h4">{{datas.data.totalicaremember}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>

      </CCol>
      <CCol sm="6" lg="3">
        <CCard >
          <CCardBody>
            <CRow>
              <CCol >
                <CRow> <font-awesome-icon color="#f9b115" class="mt-4 ml-5" icon="child"  size="3x" />
                  <CCol sm="6">
                    <CCallout color="warning">
                      <label class="text-muted">Total iCare Youth Member</label><br>
                      <strong class="h4">{{datas.data.totalicareyouthmember}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>

      </CCol>
      <CCol sm="6" lg="3">
        <CCard >
          <CCardBody>
            <CRow>
              <CCol >
                <CRow><font-awesome-icon color="#28a745 "  class="mt-4 ml-5" icon="home"  size="3x" />
                  <CCol sm="6">
                    <CCallout color="success">
                      <label class="text-muted">Total iCare Core Team</label><br>
                      <strong class="h4">{{datas.data.totalicarecoreteam}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>

      </CCol>
      <CCol sm="6" lg="3">
        <CCard >
          <CCardBody>
            <CRow>
              <CCol >
                <CRow><font-awesome-icon color="#e55353" class="mt-4 ml-5" icon="user-plus"  size="3x" />
                  <CCol sm="7">
                    <CCallout color="danger">
                      <label class="text-muted">Total iCare Youth Core Team</label><br>
                      <strong class="h4">{{datas.data.totalicarecoreteamyouth}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <!-- <CRow>
      <CCol col="12" sm="6" lg="3">
        <CWidgetIcon
          header="3.500"
          text="Total Member"
          color="success"
          :icon-padding="false"
        >
          <font-awesome-icon icon="users"  size="3x" />
        </CWidgetIcon>

      </CCol>
      <CCol col="12" sm="6" lg="3">
        <CWidgetIcon
          header="500"
          text="Total iCare"
          color="primary"
          :icon-padding="false"
        >
        {{datas.data.totalicare}}
          <font-awesome-icon icon="home"  size="3x" />
        </CWidgetIcon>
      </CCol>
      <CCol col="12" sm="6" lg="3">
        <CWidgetIcon
          header="1.800"
          text="Total iKids"
          color="warning"
          :icon-padding="false"
        >
        {{datas.data.totalikid}}
          <font-awesome-icon icon="child"  size="3x" />
        </CWidgetIcon>
      </CCol>
      <CCol col="12" sm="6" lg="3">
        <CWidgetIcon
          header="150"
          text="Total Newcomer"
          color="danger"
          :icon-padding="false"
        >
        {{datas.data.totalnewcomer}}
          <font-awesome-icon icon="user-tie"  size="3x" />
        </CWidgetIcon>
      </CCol>
    </CRow> -->

    <CRow>
      <CCol sm="6" lg="4">
          <h6>Volunteer</h6>
          <table class="table table-bordered border-primary">
            <tr><td>Total Volunteer</td><td>{{ datas.data.total_volunteer_count }}</td><td></td></tr>
            <tr><td>Male Volunteer</td><td>{{ datas.data.total_volunteer_male_count }}</td><td>{{ percent(datas.data.total_volunteer_male_count, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>Female Volunteer</td><td>{{ datas.data.total_volunteer_female_count }}</td><td>{{ percent(datas.data.total_volunteer_female_count, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>No Gender Volunteer</td><td>{{ datas.data.total_volunteer_no_gender_count}}</td><td>{{ percent(datas.data.total_volunteer_no_gender_count, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>Tahun Paling Kecil ({{ datas.data.min_dob_volunteer }})</td><td>{{ datas.data.total_volunteer_dob_min }}</td><td></td></tr>
            <tr><td>Tahun Paling Besar ({{ datas.data.max_dob_volunteer }})</td><td>{{ datas.data.total_volunteer_dob_max }}</td><td></td></tr>
            <tr><td>&#60; {{ yearNow-17 }} (&#60;17)</td><td>{{ datas.data.total_volunteer_dob_a }}</td><td>{{ percent(datas.data.total_volunteer_dob_a, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>{{ yearNow - 18 }} - {{ yearNow - 21 }} (18-21)</td><td>{{ datas.data.total_volunteer_dob_b }}</td><td>{{ percent(datas.data.total_volunteer_dob_b, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>{{ yearNow - 22 }} - {{ yearNow - 35 }} (22-35)</td><td>{{ datas.data.total_volunteer_dob_c }}</td><td>{{ percent(datas.data.total_volunteer_dob_c, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>{{ yearNow - 36 }} - {{ yearNow - 45 }} (36-45)</td><td>{{ datas.data.total_volunteer_dob_d }}</td><td>{{ percent(datas.data.total_volunteer_dob_d, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>{{ yearNow - 46 }} - {{ yearNow - 56 }} (46 - 56)</td><td>{{ datas.data.total_volunteer_dob_e }}</td><td>{{ percent(datas.data.total_volunteer_dob_e, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>{{ yearNow - 57 }} - {{ yearNow - 65 }} (57 - 65)</td><td>{{ datas.data.total_volunteer_dob_f }}</td><td>{{ percent(datas.data.total_volunteer_dob_f, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>&#62; {{ yearNow - 65 }} (&#62;65)</td><td>{{ datas.data.total_volunteer_dob_g }}</td><td>{{ percent(datas.data.total_volunteer_dob_g, datas.data.total_volunteer_count) }}</td></tr>
            <tr><td>Blank</td><td>{{ datas.data.total_volunteer_dob_h }}</td><td>{{ percent(datas.data.total_volunteer_dob_h, datas.data.total_volunteer_count) }}</td></tr>
          </table>
      </CCol>
      <CCol sm="6" lg="4">
          <h6>Volunteer Highest Age Percentage Detail</h6>
          <table class="table table-bordered border-primary">
            <tr><td>Age</td><td>Total</td></tr>
            <tr v-for="(item, i) in datas.data.total_volunteer_max_dob_detail" :key="item"><td>{{ i }}</td><td>{{ item }}</td></tr>
          </table>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6" lg="4">
          <h6>Member</h6>
          <table class="table table-bordered border-primary">
            <tr><td>Total Member</td><td>{{ datas.data.totalmember }}</td><td></td></tr>
            <tr><td>Male Member</td><td>{{ datas.data.total_member_male_count }}</td><td>{{ percent(datas.data.total_member_male_count, datas.data.totalmember) }}</td></tr>
            <tr><td>Female Member</td><td>{{ datas.data.total_member_female_count }}</td><td>{{ percent(datas.data.total_member_female_count, datas.data.totalmember) }}</td></tr>
            <tr><td>No Gender Member</td><td>{{ datas.data.total_member_no_gender_count}}</td><td>{{ percent(datas.data.total_member_no_gender_count, datas.data.totalmember) }}</td></tr>
            <tr><td>Tahun Paling Kecil ({{ datas.data.min_dob_member }})</td><td>{{ datas.data.total_member_dob_min }}</td><td></td></tr>
            <tr><td>Tahun Paling Besar ({{ datas.data.max_dob_member }})</td><td>{{ datas.data.total_member_dob_max }}</td><td></td></tr>
            <tr><td>&#60; {{ yearNow - 17 }} (&#60;17)</td><td>{{ datas.data.total_member_dob_a }}</td><td>{{ percent(datas.data.total_member_dob_a, datas.data.totalmember) }}</td></tr>
            <tr><td>{{ yearNow - 18 }} - {{ yearNow - 21 }} (18-21)</td><td>{{ datas.data.total_member_dob_b }}</td><td>{{ percent(datas.data.total_member_dob_b, datas.data.totalmember) }}</td></tr>
            <tr><td>{{ yearNow - 22 }} - {{ yearNow - 35 }} (22-35)</td><td>{{ datas.data.total_member_dob_c }}</td><td>{{ percent(datas.data.total_member_dob_c, datas.data.totalmember) }}</td></tr>
            <tr><td>{{ yearNow - 36 }} - {{ yearNow - 45 }} (36-45)</td><td>{{ datas.data.total_member_dob_d }}</td><td>{{ percent(datas.data.total_member_dob_d, datas.data.totalmember) }}</td></tr>
            <tr><td>{{ yearNow - 46 }} - {{ yearNow - 56 }} (46 - 56)</td><td>{{ datas.data.total_member_dob_e }}</td><td>{{ percent(datas.data.total_member_dob_e, datas.data.totalmember) }}</td></tr>
            <tr><td>{{ yearNow - 57 }} - {{ yearNow - 65 }} (57 - 65)</td><td>{{ datas.data.total_member_dob_f }}</td><td>{{ percent(datas.data.total_member_dob_f, datas.data.totalmember) }}</td></tr>
            <tr><td>&#62; {{ yearNow - 65 }} (&#62;65)</td><td>{{ datas.data.total_member_dob_g }}</td><td>{{ percent(datas.data.total_member_dob_g, datas.data.totalmember) }}</td></tr>
            <tr><td>Blank</td><td>{{ datas.data.total_member_dob_h }}</td><td>{{ percent(datas.data.total_member_dob_h, datas.data.totalmember) }}</td></tr>
          </table>
      </CCol>
      <CCol sm="6" lg="4">
          <h6>Member Highest Age Percentage Detail</h6>
          <table class="table table-bordered border-primary">
            <tr><td>Age</td><td>Total</td></tr>
            <tr v-for="(item, i) in datas.data.total_member_max_dob_detail" :key="item"><td>{{ i }}</td><td>{{ item }}</td></tr>
          </table>
      </CCol>
    </CRow>

    <CCard>
      <CCardBody>
        <CRow>
          <CCol sm="5">
            <h4 id="traffic" class="card-title mb-0">IFGF Surabaya</h4>
            <div class="small text-muted">April 2020</div>

          </CCol>
          <CCol sm="7" class="d-none d-md-block">
            <CButton color="primary" class="float-right">
              <CIcon name="cil-cloud-download"/>
            </CButton>
            <CButtonGroup class="float-right mr-3">
              <CButton
                color="outline-secondary"
                v-for="(value, key) in ['Day', 'Month', 'Year']"
                :key="key"
                class="mx-0"
                :pressed="value === selected ? true : false"
                @click="selected = value"
              >
                {{value}}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
        <MainChartExample style="height:300px;margin-top:40px;"/>
      </CCardBody>
      <CCardFooter>
        <CRow class="text-center">
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Visits</div>

            <strong>500 People (100%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="success"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Covenant in Church</div>
            <strong>50 People (10%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="info"
              :value="10"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Only Visits</div>
            <strong> 380 People (65%) </strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="warning"
              :value="65"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">From Another Church</div>
            <strong>80 People (15%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="danger"
              :value="18"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">From Another IFGF</div>
            <strong>120 People (15%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="primary"
              :value="30"
            />
          </CCol>

        </CRow>
      </CCardFooter>
    </CCard>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            New Volunteer in Department
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12" lg="6">
                <CRow>
                  <CCol sm="6">
                    <CCallout color="info">
                      <small class="text-muted">Praise & Worship</small><br>
                      <strong class="h4">5</strong>
                    </CCallout>
                  </CCol>
                  <CCol sm="6">
                    <CCallout color="danger">
                      <small class="text-muted">Consellor</small><br>
                      <strong class="h4">20</strong>
                    </CCallout>
                  </CCol>
                </CRow>
                <hr class="mt-1">

               <div class="progress-group">
                    <div class="progress-group-header">
                      <CIcon name="cil-user" class="progress-group-icon"/>
                      <span class="title">Male</span>
                      <span class="ml-auto font-weight-bold">2,700 People (53%)  </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="43"
                        color="warning"
                      />
                    </div>
                  </div>
              </CCol>
              <CCol sm="12" lg="6">
                <CRow>
                  <CCol sm="6">
                    <CCallout color="warning">
                      <small class="text-muted">Choir</small><br>
                      <strong class="h4">18</strong>
                    </CCallout>
                  </CCol>
                  <CCol sm="6">
                    <CCallout color="success">
                      <small class="text-muted">Connect Team</small><br>
                      <strong class="h4">50</strong>
                    </CCallout>
                  </CCol>
                </CRow>
                <hr class="mt-0">
                <ul class="horizontal-bars type-2">

                  <div class="progress-group mb-3">
                    <div class="progress-group-header">
                      <CIcon name="cil-user-female" class="progress-group-icon"/>
                      <span class="title">Female</span>
                      <span class="ml-auto font-weight-bold"> 2,300 People (47%) </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="37"
                        color="warning"
                      />
                    </div>
                  </div>
                </ul>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
     <!-- <pre>{{ $data | json }}</pre> -->

  </div>
</template>

<script>
import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from './widgets/WidgetsDropdown'
import WidgetsBrand from './widgets/WidgetsBrand'

import axios from 'axios'

import dashboard from '@/services/dashboard'

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

export default {
  name: 'Dashboard',
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand
  },
  data () {
    return {
      datas:[],
      selected: 'Month',
      tableItems: [
        {
          avatar: { url: 'img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          activity: '10 sec ago'
        } ],
      tableFields: [
        { key: 'avatar', label: '', _classes: 'text-center' },
        { key: 'user' },
        { key: 'activity' },
      ],
      yearNow: new Date().getFullYear()
    }
  },

  mounted(){
    this.load()
  },

  computed: {
    percent: function () {
      return function (x,y) {
          var c = x/y*100
          return parseFloat(c).toFixed(2) + "%"
      };
   }
  },

  methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },

    load(){
     dashboard.getDashboard(this.$route.query.Pud)
      .then(res => {
        this.datas =res

    })
    },
  }
}
</script>
